/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum RoleName {
    USER = 'user',
    ADMIN = 'admin',
    ACCOUNTANT = 'accountant',
    HR = 'hr',
    RECRUITER = 'recruiter',
    LAWYER = 'lawyer',
}
